import pegasus from "../../../../assets/scripts/global/01-pegasus";
import Alpine from 'alpinejs';

/**
 * IP detection and modal for select the right territory
 */
export class IpDetectionBar {
    visible = false;
    matchingLocation = true;
    currentView = '';
    show = false;
    selector = null;
    territory = null;
    origSelection = null;
    destination = null;

    init() {
        this.selector = document.getElementById('ip-select');
        this.origSelection = this.selector.selectedIndex;
        if (this.selector) {
            this.formatSelector(this.selector)
        }
        this.getIPInfo();
    }

    hideAndSave() {
        const selectorOptions = this.selector.querySelectorAll('option');
        const selectedTerritory = selectorOptions[this.origSelection].dataset.territoryId;
        pegasus.setCookie('IP_VERIFIED', JSON.stringify({territory: selectedTerritory}));

        if (parseInt(this.currentView) === parseInt(selectedTerritory)) {
            this.show = false;
        } else {
            window.location.href = selectorOptions[this.origSelection].value;
        }
    }

    territorySelect(href) {
        const selectorOptions = this.selector.querySelectorAll('option');
        const selectedTerritory = selectorOptions[this.selector.selectedIndex].dataset.territoryId;

        pegasus.setCookie('IP_VERIFIED', JSON.stringify({territory: selectedTerritory}));

        if (parseInt(this.currentView) === parseInt(selectedTerritory)) {
            this.show = false;
        } else {
            if(this.destination !== null) {
                window.location.href = this.destination;
            } else {
                window.location.href = href;
            }
        }
    }

    getIPInfo() {
        let IPCookie;

        if (pegasus.getCookie('IP_VERIFIED') !== undefined) {
            IPCookie = pegasus.getCookie('IP_VERIFIED');
        }

        const data = new FormData();
        data.append('action', 'ip_detect_notify');
        data.append('url', window.location.href);

        fetch(ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            body: data
        }).then(async resp => {
            const data = await resp.json();

            if (data.current_view !== undefined) {
                this.currentView = data.current_view;
            }

            if (typeof IPCookie !== 'undefined' && IPCookie !== '') {
                IPCookie = JSON.parse(IPCookie);
                if (parseInt(IPCookie.territory) === data.current_view) {
                    data.show_bar = false;
                }
                this.territory = parseInt(IPCookie.territory);
            }

            if (data.show_bar !== undefined) {
                this.matchingLocation = !data.show_bar;

                setTimeout(() => {
                    this.show = data.show_bar;
                }, 500)
            }

            return data
        }).then(data => {
            if(typeof data.destination !== 'undefined' && data.destination !== '') {
                this.destination = data.destination;
            }

            if (this.matchingLocation === false) {
                if (typeof IPCookie !== 'undefined' && IPCookie !== '') {
                    if (parseInt(IPCookie.territory) === parseInt(document.body.dataset.territory)) {
                        this.matchingLocation = true;
                        this.show = false;
                    }
                }
                const countrySelector = this.$root.querySelector('select');
                countrySelector.value = data.should_view_home;
                countrySelector.dispatchEvent(new Event('change'));
            }
        });
    }

    formatSelector(selector) {
        // Override this method in extends to change the appearance of the selector
    }
}
Alpine.data('ipDetectionBar', () => new IpDetectionBar());

/**
 * Territory switcher dropdown
 */
export class TerritorySwitch {
    switcher = null;
    selectedTerritory = null;
    init() {
        this.switcher = document.getElementById('ip-switcher');
        if (this.switcher) {
            this.formatSelector(this.switcher)
        }
    }

    territorySelect(href) {
        window.location.href = href;
    }

    formatSelector(selector) {
        // Override this method in extends to change the appearance of the selector
    }
}
Alpine.data('territorySwitch', () => new TerritorySwitch());
